import {createStore} from 'vuex'
import layout from './modules/layout';
import menu from './modules/menu';
import auth from '@/modules/auth/store';
import diagnostics from '@/modules/diagnostics/store';
import workPlans from '@/modules/work-plans/store';
import chat from '@/modules/chat/store';


export default createStore({
  state:{langIcon: '',langLangauge: '',isActive:false, isGeneralLoading: false},
  getters:{
    langIcon: (state)=>{ return state.langIcon},
    langLangauge:(state)=>{return state.langLangauge},
    getGeneralLoading: (state) => state.isGeneralLoading
  },
  mutations: {
      changeLang (state, payload) {
        localStorage.setItem('currentLanguage', payload.id);
        localStorage.setItem('currentLanguageIcon', payload.icon);
        state.langIcon = payload.icon || 'flag-icon-us'
        state.langLangauge = payload.id || 'EN'
        // window.location.reload();
      },
      change(state){
        state.isActive = !state.isActive
      },
      setGeneralLoading(state, payload) {        
        state.isGeneralLoading = payload;
      }
    },
    actions: {
      setLang ({ commit }, payload) {
        commit('changeLang', payload);
        
      }
    },
    modules: {
      layout,
      menu,
      auth,
      diagnostics,
      workPlans,
      chat
    }
});

